import { BaseBus } from "./BaseBus";
import { v_DispatchNoteBus } from './v_DispatchNoteBus';

export class v_DispatchGrid2Bus extends BaseBus {
    dispatchId: any;
    quoteId: any;
    dispatchNumber: string;
    ponumber: string;
    wonumber: string;
    quoteNumber: string;
    invoiceNumber: string;
    daysInStatus: number;
    lastStatusChangeDt: Date;
    receivedDateTime: Date;
    notToExceed: number;
    dispatchStatusName: string;
    dispatchStatusCategory: string;
    locationName: string;
    customerId: string;
    customerName: string;
    color: number;
    priorityColor: string;
    dispatchBoardColor: number;
    boardColorHex: string;
    priorityName: string;
    dispatchReason: string;
    AccountClassName: string;
    invoiceAmt: number;
    locationId: any;
    isOpen: boolean;
    dispatchNotes: v_DispatchNoteBus[];
    receivedDateTimeStr: string;
    contractAdminName: string;
    isConstruction: boolean;
    contractAdminId: string;
    masterJobId: any;
    masterJobNumber: string;
    divisionId: any;
    divisionName: any;
    billerId: any;
    billerName: any;
    assignedPerson: any;
    visitCount: number;
    hasOpenConstContracts: boolean;
    onCallRegionName: string;
    discreetBillerId: any;
    defaultSubmitterId: any;
    invoiceEstimate: number;
    finalBillingDt: Date;
    conFinalBillingDt: Date;
    dispatchRankOrderId: any;
    rankLevel: string;
    timeValue: number;
    timeText: string;
    colorcode: string;
    costAmt: number;
    acctMgrName: string;
    daysAged: number;
    estimatedCost: number;
    salesOrderId: any;
    salesOrderNumber: string;
    purchaserName: string;
    prioritySubTypeName: string;
    prioritySubTypeId: any;
    projectManagerId: any;
    quoteDate: Date;
    quoteStatusName: string;
    isPassThrough: boolean;
    changeOrderInfo: string;
    changeReqInfo: string;
    quoteStatusDate: Date;
    totalQuote: number;
    contractPM: string;

}
